import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchCompany = createAsyncThunk(
  'company/fetchCompany',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetCompany();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  companyList: [],
  loading: false,
  error: '',
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companyList = action.payload;
        state.error = '';
      })
      .addCase(fetchCompany.rejected, (state, action) => {
        state.loading = false;
        state.companyList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default companySlice.reducer;
